import { render, staticRenderFns } from "./ReviewsCategoriesHeatmap.vue?vue&type=template&id=f35b7a70&scoped=true&"
import script from "./ReviewsCategoriesHeatmap.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesHeatmap.vue?vue&type=style&index=0&id=f35b7a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35b7a70",
  null
  
)

export default component.exports